export default "__VITE_ASSET__YMnOgj81__"